import React, { useState } from 'react';
import { yyyymmdd, isBetweenFromAndToDates, useDebounce } from 'services/Dates';
import { isEmpty } from 'lodash';

const DateInput = ({
  className = '',
  minDate,
  maxDate,
  defaultDate = '',
  onChange,
  onClear = () => {}
}) => {
  const [date, setDate] = useState(null);
  const handleChange = (e) => {
    setDate(e.target.value || '');
  };

  // useEffect with debounce
  useDebounce(() => {
    if (isEmpty(date)) {
      onClear();
      return;
    }

    if (isBetweenFromAndToDates(date, minDate, maxDate)) {
      onChange(date);
    } else {
      console.log(`Invalid Date`);
    }
  }, [date, minDate, maxDate]);

  return (
    <input
      type={'date'}
      placeholder={'MM/DD/YYYY'}
      className={className}
      min={yyyymmdd(minDate)}
      max={yyyymmdd(maxDate)}
      value={date === null ? defaultDate : date}
      onChange={handleChange}
    />
  );
};

export default DateInput;
